import React, { ReactNode } from "react"
import styles from "./AppHeader.module.scss"
import { NavLink } from "react-router-dom"
import { AppLogo } from "components/common/AppLogo/AppLogo"
import { ArrowDownSelect } from "components/common/ArrowDownSelect"
//import container from "components/common/Container/Container.module.scss"


export const AppHeader = () => {
    return (
        <header className={styles.appHeader}>
            <div className={styles.headerContent}>
                <div className={styles.left}>
                    <AppLogo/>
                    <ButtonLink>Частые вопросы</ButtonLink>
                </div>
                <div className={styles.right}>
                    <LangsSelect/>
                    <UserLogin/>
                </div>
            </div>
        </header>
    )
}


const LangsSelect = () => {
    return (
        <div className={styles.selectBlock}>
            <select className={styles.langsList} name="lang">
                <option value="RU">RU</option>
                <option value="EN">EN</option>
            </select>
            <ArrowDownSelect 
                width="12"
                height="6"
                fill="none"
                stroke="#F1F2F3"
                strokeWidth="2"
            />
        </div>

    )
}


const UserLogin = () => {
    return (
        <div className={styles.loginBlock}>
            <NavLink className={styles.loginLink} to="/pa">Войти</NavLink>
            <ButtonLink>Зарегистрироваться</ButtonLink>
        </div> 
    )
}


const ButtonLink = ({children} : {children: ReactNode}) => {
    return (
        <NavLink className={styles.btnLink} to="/faq">
            { children }
        </NavLink>
    )
}